import * as React from 'react';
import { Form } from 'react-final-form';
import { useDispatch } from 'react-redux';

import { FIELD_PATHS } from '@funnels/constants';
import { updateApplication } from '@funnels/redux-store';
import { FormValuesApplications } from '@funnels/types';
import { Modals, TextInputField } from '@funnels/ui-components';

interface TitleFormProps {
  initialValues?: FormValuesApplications;
  isVisible: boolean;
  onHide: () => void;
  onAction: () => void;
  onSubmit: () => void;
  hidePrimaryButton?: boolean;
}

function TitleFormModal(props: TitleFormProps) {
  const dispatch = useDispatch();
  const { initialValues, onSubmit, onAction, hidePrimaryButton = false, ...rest } = props;

  function handleSubmit(values: FormValuesApplications) {
    dispatch(updateApplication(values.applications[0]));
    onSubmit();
  }

  return (
    <Form initialValues={initialValues} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <Modals.Action
          title="Rename application"
          actionPrimaryButtonLabel="Save"
          onAction={handleSubmit}
          {...rest}
          hidePrimaryButton={hidePrimaryButton}
        >
          <TextInputField
            label="New application name"
            name={FIELD_PATHS.APPLICATION_NAME(0)}
            disabled={hidePrimaryButton}
          />
        </Modals.Action>
      )}
    </Form>
  );
}

export default TitleFormModal;
